/**
 * Bo+Tee Media Banner — play/pause for the section's own background video.
 * Does not touch videos outside this host.
 */
class BtMediaBanner extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #button = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#stopVideos();
    }

    const button = this.querySelector('[data-bt-mb-pause]');
    if (!(button instanceof HTMLButtonElement)) return;

    this.#button = button;
    button.addEventListener('click', this.#onToggle);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#onToggle);
    this.#button = null;
  }

  /** @param {MouseEvent} event */
  #onToggle = (event) => {
    event.preventDefault();
    const button = this.#button;
    if (!button) return;

    const videos = this.#videos();
    if (videos.length === 0) return;

    const playing = button.dataset.playing === 'true';
    const pauseIcon = button.querySelector('[data-icon-pause]');
    const playIcon = button.querySelector('[data-icon-play]');

    if (playing) {
      videos.forEach((video) => video.pause());
      button.dataset.playing = 'false';
      button.setAttribute('aria-label', button.dataset.playLabel || 'Play video');
      pauseIcon?.setAttribute('hidden', '');
      playIcon?.removeAttribute('hidden');
      return;
    }

    videos.forEach((video) => {
      video.play().catch(() => {});
    });
    button.dataset.playing = 'true';
    button.setAttribute('aria-label', button.dataset.pauseLabel || 'Pause video');
    playIcon?.setAttribute('hidden', '');
    pauseIcon?.removeAttribute('hidden');
  };

  #stopVideos() {
    this.#videos().forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  /** @returns {HTMLVideoElement[]} */
  #videos() {
    return Array.from(this.querySelectorAll('video'));
  }
}

if (!customElements.get('bt-media-banner')) {
  customElements.define('bt-media-banner', BtMediaBanner);
}
